/* eslint-disable camelcase */

import { useEffect, useState } from 'react';
import { trackError } from 'helpers/track_error';
import { useSignupContext } from '../signupProvider';
import type { CompanyLead } from './types';

export default function useCompanyLead() {
  const [loading, setLoading] = useState(true);
  const [fromSSO, setFromSSO] = useState(false);
  const [ssoProvider, setSsoProvider] = useState('');
  const [companyLead, setCompanyLead] = useState<CompanyLead>({});
  const { submissionOrigin, fromBd } = useSignupContext();
  const [isCompanyLeadEmpty, setIsCompanyLeadEmpty] = useState(true);

  useEffect(() => {
    fetch('/sign_up_form_data')
      .then(response => response.json())
      .then(data => {
        const ssoData = data?.gsso_data || data?.intuit_sso_data;
        const companyName = ssoData?.company_name;
        const savedCompanyName = data?.company_lead?.company_name;

        if (data?.intuit_sso_data) {
          setSsoProvider('intuit');
        }

        // checks if companylead is empty; does this by checking if data is empty for any property
        if (data.gsso_data || data.intuit_sso_data || data.company_lead) {
          setIsCompanyLeadEmpty(false);
        }

        // set props similar as app/views/company_leads/_survey_signup_modal.html.haml
        setCompanyLead({
          company_name: companyName || savedCompanyName || '',
          first_name: ssoData?.given_name || data?.company_lead?.first_name || '',
          last_name: ssoData?.family_name || data?.company_lead?.last_name || '',
          email: ssoData?.email || data?.company_lead?.email || '',
          number_employees: ssoData?.number_employees || data?.company_lead?.number_employees || 0,
          phone: ssoData?.phone || data?.company_lead?.phone || '',
          submitted_from: fromBd
            ? 'BdLandingPage'
            : data?.company_lead?.submitted_from || data?.company_lead?.source || submissionOrigin,
          sold_by: data?.company_lead?.sold_by || null,
          sold_by_accountant_id: data?.company_lead?.sold_by_accountant_id || null,
          campaign: data?.company_lead?.campaign || null,
          industry: data?.company_lead?.industry || null,
        });
        if (ssoData && ssoData?.email) {
          setFromSSO(true);
        }

        setLoading(false);
      })
      .catch(() => {
        trackError({
          error: new Error(`Error getting data from /sign_up_form_data`),
        });
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { loading, fromSSO, ssoProvider, companyLead, isCompanyLeadEmpty };
}
